import { render, staticRenderFns } from "./MobileCollapsedAddress.vue?vue&type=template&id=a4927728&scoped=true"
import script from "./MobileCollapsedAddress.vue?vue&type=script&lang=ts"
export * from "./MobileCollapsedAddress.vue?vue&type=script&lang=ts"
import style0 from "./MobileCollapsedAddress.vue?vue&type=style&index=0&id=a4927728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4927728",
  null
  
)

export default component.exports